import type { PresetColorType } from 'antd/es/_util/colors';

import type { BookingReviewStatus } from 'app/typings/core/admin/bookings/enum/bookingReviewStatus';

type FormatUserReview = {
  [key in BookingReviewStatus]: {
    label: string;
    color?: PresetColorType;
  };
};

export const formatBookingReviewStatus = (
  reviewStatus: BookingReviewStatus
): FormatUserReview[BookingReviewStatus] => {
  // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
  const formatBookingReviewStatus: FormatUserReview = {
    UNPUBLISHED: {
      label: 'Unpublished',
      color: 'red',
    },
    PUBLISHED: {
      label: 'Published',
      color: 'green',
    },
  };

  return formatBookingReviewStatus[reviewStatus];
};
